import { render, staticRenderFns } from "./PorudzbeDostava.vue?vue&type=template&id=e6a872d6&scoped=true"
import script from "./PorudzbeDostava.vue?vue&type=script&lang=js"
export * from "./PorudzbeDostava.vue?vue&type=script&lang=js"
import style0 from "./PorudzbeDostava.vue?vue&type=style&index=0&id=e6a872d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a872d6",
  null
  
)

export default component.exports